
import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { Send } from 'lucide-react';
import { applicationSchema, ApplicationFormData } from './application-form/ApplicationFormSchema';
import { useApplicationFormSubmit } from './application-form/useApplicationFormSubmit';
import PersonalInfoFields from './application-form/PersonalInfoFields';
import JobInfoFields from './application-form/JobInfoFields';
import MotivationField from './application-form/MotivationField';
import FileUploadSection from './application-form/FileUploadSection';

const ApplicationForm = () => {
  const { isSubmitting, submitApplication } = useApplicationFormSubmit();

  const form = useForm<ApplicationFormData>({
    resolver: zodResolver(applicationSchema),
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      jobPosition: '',
      experience: '',
      motivation: '',
    },
  });

  const onSubmit = async (data: ApplicationFormData) => {
    const success = await submitApplication(data);
    if (success) {
      form.reset();
    }
  };

  return (
    <section id="application-form" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <Card className="max-w-2xl mx-auto">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl md:text-3xl font-heading text-fabre-gray">
              Postulez maintenant
            </CardTitle>
            <p className="text-gray-600">
              Remplissez le formulaire ci-dessous pour nous envoyer votre candidature
            </p>
          </CardHeader>
          <CardContent>
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
                <PersonalInfoFields form={form} />
                <JobInfoFields form={form} />
                <MotivationField form={form} />
                <FileUploadSection />

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-fabre-green hover:bg-fabre-darkgreen"
                  size="lg"
                >
                  {isSubmitting ? (
                    "Préparation de l'email..."
                  ) : (
                    <>
                      <Send className="mr-2 h-5 w-5" />
                      Envoyer ma candidature
                    </>
                  )}
                </Button>
              </form>
            </Form>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ApplicationForm;
